import React from 'react'
import Modal from 'react-modal'

export default class Footer extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isModalOpen: false
    }
  }

  _onClick (e) {
    e.preventDefault()
    const isModalOpen = !this.state.isModalOpen

    this.setState({ isModalOpen })
  }

  render () {
    const { isModalOpen } = this.state
    const customStyles = {
      content: {
        top: '20px',
        right: '20px',
        bottom: '20px',
        left: '20px'
      }
    }

    return (
      <div className="footer">
        <Modal
          isOpen={isModalOpen}
          onRequestClose={(e) => this._onClick(e)}
          shouldCloseOnOverlayClick={true}
          style={customStyles}
          contentLabel="About/Privacy"
        >
          <h1>About</h1>
          <p>One Card was made to cut out the hassle from splitting the bill at group dinners.</p>
          <p>If you have any feedback get in touch <a href="https://twitter.com/molchanimal">@molchanimal</a>!</p>
          <h1>Privacy</h1>
          <p>One Card does not and will not ever store or use your data.</p>
          <p>
            Google analytics are used on this page simply to track page views. No analytics or
            serverside events happen when you use the form or click Pay.
          </p>
          <button onClick={(e) => this._onClick(e)}>Close</button>
        </Modal>
        <a href="" className="footer-link" onClick={(e) => this._onClick(e)}>About/Privacy</a>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/components/Footer.js
 **/